import { Box, FormControlLabel, Switch } from "@mui/material";
import { useState } from "react";
import UpgradeDialog from "../Dialogs/UpgradeDialog";
import UpgradeDialogV2 from "../Dialogs/UpgradeDialogV2";

const realTimeInsightsUpgradeDialog = {
    title: "Unlock Real-Time Insights",
    subtitle: "Gain deeper insights into your QR code performance and fully customize its behavior.",
    features: [
      {
        primary: "Live QR Code Scan Monitoring",
        secondary: "Track every scan in real-time with instant analytics and reporting."
      },
      {
        primary: "User Engagement Insights",
        secondary: "Analyze scan frequency, location, and device types to understand your audience."
      },
      {
        primary: "Dynamic QR Code Customization",
        secondary: "Modify QR code content, URLs, and settings anytime without reprinting."
      },
      {
        primary: "A/B Testing for QR Codes",
        secondary: "Test different QR destinations and optimize performance based on real-time data."
      },
      {
        primary: "Custom Branding & Design",
        secondary: "Personalize QR codes with logos, brand colors, and unique styling."
      },
      {
        primary: "Deep Data Export & API Access",
        secondary: "Integrate analytics into your existing systems with API access and exportable data."
      }
    ]
  };
  
  
const RealtimeInsightsSwitch = () => {
    const [openUpgradeDialog, setOpenUpgradeDialog] = useState(false);
    const [isSwitchOn, setIsSwitchOn] = useState(false);

    const onSwitch = () => {
        setOpenUpgradeDialog(true);
        setIsSwitchOn(false); 
    };

    return(
        <>
            <Box>
                <FormControlLabel
                    control={
                        <Switch
                            sx={{ color: "#000" }}
                            checked={isSwitchOn}
                            onChange={onSwitch}
                        />
                    }
                    label="Real-Time Insights & Customization"
                />
            </Box>
            <UpgradeDialogV2 
                open={openUpgradeDialog} 
                onClose={() => setOpenUpgradeDialog(false)} 
                title={realTimeInsightsUpgradeDialog.title}
                subtitle={realTimeInsightsUpgradeDialog.subtitle}
                requestedFeature="qr"
            />

        </>
    )
}

export default RealtimeInsightsSwitch;